
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wukong-reviews",
      function () {
        return require("private-next-pages/wukong-reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wukong-reviews"])
      });
    }
  